import React from 'react';
import './Careers.css';

const Careers = () => {
  const openPositions = [
    {
      title: 'PLC Programmer - Beckhoff',
      department: 'Service / Commissioning Team',
      location: 'Remote - USA',
      type: 'Full-time',
      description: 'We are seeking an experienced PLC Programmer specializing in Beckhoff systems to join our Service and Commissioning Team. You will be responsible for programming, commissioning, and supporting Beckhoff control systems for our clients.'
    },
    {
      title: 'PLC Programmer - Rockwell',
      department: 'Service / Commissioning Team',
      location: 'Remote - USA',
      type: 'Full-time',
      description: 'We are seeking an experienced PLC Programmer specializing in Rockwell (Allen-Bradley) systems to join our Service and Commissioning Team. You will be responsible for programming, commissioning, and supporting Rockwell control systems for our clients.'
    },
    {
      title: 'PLC Programmer - Rockwell (Packing & Robotics)',
      department: 'Service / Commissioning Team',
      location: 'Remote - USA',
      type: 'Full-time',
      description: 'We are seeking an experienced PLC Programmer with expertise in Rockwell systems, specifically in packing applications. Must have experience with Delta Robots, Vision Systems for feedback to pick on the fly, and Motion Coordinate Systems from Rockwell. You will work on high-speed packing solutions with integrated robotics and vision feedback.'
    },
    {
      title: 'Sales Engineer',
      department: 'Sales and Applications Team',
      location: 'Remote - USA',
      type: 'Full-time',
      description: 'We are seeking a Sales Engineer to join our team. You will work with potential clients to understand their automation needs, provide technical solutions, and help grow our business. Experience in industrial automation, manufacturing, or related fields is preferred.'
    },
    {
      title: 'Robot Programmer',
      department: 'Service / Commissioning Team',
      location: 'Remote - USA',
      type: 'Full-time',
      description: 'We are seeking an experienced Robot Programmer to join our Service and Commissioning Team. You must have experience programming and commissioning industrial robots from leading manufacturers including Fanuc, Kuka, ABB, Epson, and Staubli. You will be responsible for robot programming, path optimization, safety system integration, and commissioning robotic systems for our clients across the USA.'
    },
    {
      title: 'Software Developer',
      department: 'Software Engineering Team',
      location: 'Remote - USA',
      type: 'Full-time',
      description: 'We are seeking an experienced Software Developer to join our Software Engineering Team. You must have strong experience with ASP.NET, C#, Microsoft SQL Server, and web development technologies. You will develop custom software solutions for manufacturing, including web applications, dashboards, and enterprise integration systems.'
    },
    {
      title: 'SCADA Programmer',
      department: 'Software Engineering Team',
      location: 'Remote - USA',
      type: 'Full-time',
      description: 'We are seeking an experienced SCADA Programmer to join our Software Engineering Team. You must have experience developing and programming SCADA systems including Ignition, Wonderware, WinCC, Rockwell FactoryTalk, and GE Digital. You will be responsible for designing, developing, and implementing SCADA solutions for industrial automation projects.'
    },
    {
      title: 'Vision Programmer',
      department: 'Software Engineering Team',
      location: 'Remote - USA',
      type: 'Full-time',
      description: 'We are seeking an experienced Vision Programmer to join our Software Engineering Team. You must have experience with traditional vision systems (Cognex, Keyence) and custom computer vision development using OpenCV with Python, C++, or C#. Knowledge of deep learning frameworks such as PyTorch and TensorFlow is highly desirable. You will develop vision solutions for quality control, inspection, and guidance applications.'
    }
  ];

  const benefits = [
    'Competitive salary and benefits package',
    'Health, dental, and vision insurance',
    '401(k) retirement plan',
    'Professional development opportunities',
    'Collaborative work environment',
    'Opportunity to work on cutting-edge automation projects'
  ];

  return (
    <div className="careers-page">
      <section className="page-hero">
        <div className="container">
          <h1>Careers</h1>
          <p className="page-hero-subtitle">
            Join our team and help shape the future of industrial automation
          </p>
        </div>
      </section>

      <section className="careers-content">
        <div className="container">
          <div className="careers-intro">
            <h2>Why Work at SCE Automated?</h2>
            <p>
              At SCE Automated, we're building the future of industrial automation. 
              We're looking for talented, passionate individuals who want to make a 
              real impact in manufacturing. Join us and work on challenging projects 
              with cutting-edge technology while being part of a collaborative, 
              innovative team.
            </p>
          </div>

          <div className="benefits-section">
            <h2>Benefits & Perks</h2>
            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="open-positions">
            <h2>Open Positions</h2>
            {openPositions.length > 0 ? (
              <div className="positions-list">
                {openPositions.map((position, index) => (
                  <div key={index} className="position-card">
                    <div className="position-header">
                      <h3>{position.title}</h3>
                      <div className="position-meta">
                        <span className="position-department">{position.department}</span>
                        <span className="position-location">{position.location}</span>
                        <span className="position-type">{position.type}</span>
                      </div>
                    </div>
                    <p className="position-description">{position.description}</p>
                    <a href="/contact" className="btn">Apply Now</a>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-positions">
                <p>We don't have any open positions at the moment, but we're always interested in hearing from talented individuals.</p>
                <a href="/contact" className="btn btn-primary">Send Us Your Resume</a>
              </div>
            )}
          </div>

          <div className="careers-cta">
            <h2>Don't See a Position That Fits?</h2>
            <p>We're always looking for talented individuals. Send us your resume and we'll keep you in mind for future opportunities.</p>
            <a href="/contact" className="btn btn-primary">Contact Us</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Careers;

